<div
  class="marker relative bg-white rounded-xl p-2 flex flex-col gap-4 min-w-full !border-[#B4BFCB] border border-solid !z-50 !min-w-[20rem]"
  style="width: min(24rem, 90%); transform: translateX(-50%) translateY(-150%)"
  [dir]="direction"
  >
  <div class="flex justify-between items-start max-w-full">
    <div class="flex flex-col">
      <!--
        a11y: map marker popover heading is h2 (the page already owns the primary
        <h1> via the nav-bar logo). `color="primary"` is non-standard on a
        heading element but is preserved here intentionally — it's only used by a
        scoped style hook, not as an HTML attribute.
      -->
      <h2 color="primary" class="m-0 font-bold text-base">
        {{ data.address.addressDetails.street && data.address.addressDetails.houseNumber ?
        data.address.addressDetails.street  + ' ' + data.address.addressDetails.houseNumber :
        data.address.addressDetails.street || data.address.addressDetails.label }}
      </h2>
      <span class="text-[#5C748F] m-0">{{ data.address.addressDetails.city }}</span>
    </div>
  </div>

  @if (!isInMobileView()) {
    <div class="flex flex-wrap gap-2">
      <mot-button
        buttonClass="choose-origin !bg-primary !px-2 flex-1 !text-white !rounded-xl !align-middle"
        [text]="originButtonTitle"
        >
      </mot-button>
      <mot-button
        buttonClass="choose-destination !bg-primary !px-2 flex-1 !text-white !rounded-xl !align-middle"
        [text]="destinationButtonTitle"
        >
      </mot-button>
      @if (data.showAddStopButton) {
        <mot-button
          buttonClass="choose-stop !bg-primary !px-2 flex-1 !text-white !rounded-xl !align-middle"
          [text]="addStopButtonTitle"
          >
        </mot-button>
      }
    </div>
  }

  @if (isInMobileView()) {
    <mot-button
      buttonClass="choose-address !bg-primary !px-2 flex-1 !text-white !rounded-xl !align-middle"
      [text]="chooseAddressText"
      >
    </mot-button>
  }

  <button
    type="button"
    class="close-station-data !p-0 !w-8 !h-8 border-none bg-transparent absolute top-1 flex items-center justify-center cursor-pointer"
    [ngClass]="direction === 'rtl' ? 'left-4' : 'right-4'"
    [attr.aria-label]="closeText">
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
      <path d="M16.1875 9.21875L13.4062 12L16.1875 14.8125L16.9062 15.5L15.5 16.9375L14.7812 16.2188L12 13.4375L9.1875 16.2188L8.5 16.9375L7.0625 15.5L7.78125 14.8125L10.5625 12L7.78125 9.21875L7.0625 8.5L8.5 7.09375L9.1875 7.8125L12 10.5938L14.7812 7.8125L15.5 7.09375L16.9062 8.5L16.1875 9.21875Z" fill="#0C3058"/>
    </svg>
  </button>

</div>
